import { ICArea } from "./icarea";
import { ICCamera } from "./iccamera";
import { ICCasher } from "./iccasher";
import { ICData } from "./icdata";
import { ICHeatmap } from "./icheatmap";
import { ICLight } from "./iclight";

export class ICObjective {
  Area: ICArea;
  AreaId: number;
  Camera: ICCamera;
  CameraId: number;
  Cashers: ICCasher[];
  Code: string;
  Datas: ICData[];
  DeleteDate: string;
  Heatmaps: ICHeatmap[];
  Id: number;
  IdGuid: string;
  InsertDate: string;
  LastEditDate: string;
  Lights: ICLight[];
  PathCasherFormat: string;
  PathHeatMapFormat: string;
  PathIdeoGateFormat: string;
  PathIdeoGateStayFormat: string;
  PathLightFormat: string;
  PathPeopleCountingFormat: string;
  Paths: string[];

  constructor(data?: Partial<ICObjective>) {
    Object.assign(this, data);
  }
}
